import { render, staticRenderFns } from "./Registros.vue?vue&type=template&id=96f06fb6&scoped=true&"
import script from "./Registros.vue?vue&type=script&lang=js&"
export * from "./Registros.vue?vue&type=script&lang=js&"
import style0 from "./Registros.vue?vue&type=style&index=0&id=96f06fb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f06fb6",
  null
  
)

export default component.exports